import * as $ from 'jquery';

$(() => {
    const navbarContainer = $('header');

    // If we are not on send tickets page we stop script
    if (navbarContainer.length === 0) {
        return;
    }
});
